import {takeEvery} from 'redux-saga/effects'
import {
  ADD_TAG,
  DELETE_TAG,
  GET_TAG,
  GET_TAGS,
  UPDATE_TAG,
} from 'setup/redux/Actions/School/Tags/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_TAGS, fetchData)
  yield takeEvery(GET_TAG, fetchData)
  yield takeEvery(ADD_TAG, fetchData)
  yield takeEvery(UPDATE_TAG, fetchData)
  yield takeEvery(DELETE_TAG, fetchData)
}

export default dataSaga
